import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { T2TemplateBasicComponent } from 'app/trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { DashboardProvidersComponent } from './dashboard-providers.component';

const routes: Routes = [
  {
    path: 'pages',
    component: T2TemplateBasicComponent,
    children: [
      {
        path: 'providers-dashboard',
        component: DashboardProvidersComponent,
        data: { title: 'Dashboard'}
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class DashboardProvidersRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-providers/dashboard-providers-routing.module.ts